import { Tabs, Tooltip } from "antd";
import { FC } from "react";
import { Styles } from "./styled";
import useCategoryStatusConfig, {
  BUSINESS_MANUALS_SUB_TABS,
  CATEGORY_STATUS_TABS,
  Props,
  ReceivedProps,
} from "./hook";
import BizSheetCategoryStatus from "./components/BizSheet";
import WorkerListCategoryStatus from "./components/WorkerList";
import ProjectManagementStatus from "./components/ProjectManagement";
import BusinessTripReportsCategoryStatus from "./components/BusinessTripReports";
import CompanyPoliciesCategoryStatus from "./components/CompanyPolicies";
import CustomerCategoryStatus from "./components/Customer";
import BusinessManualsCategoryStatus from "./components/BusinessManuals";

const CategoryStatusConfigLayout: FC<Props> = ({
  activeKey,
  onChange,
  businessManualSubTab,
  onBusinessManualSubTabChange,
  displaySize,
  height,
  size,
}) => {
  return (
    <Styles text_scale={displaySize}>
      <h2 className="title-button">カテゴリーとステータスの設定</h2>

      <div className="p-3 background-white">
        <Tabs
          defaultActiveKey={CATEGORY_STATUS_TABS.WORKERS.key}
          activeKey={activeKey}
          onChange={onChange}
          className="tab-custom"
        >
          {/* <Tabs.TabPane
            tab={CATEGORY_STATUS_TABS.STAFF_TAX_SHEET.label}
            key={CATEGORY_STATUS_TABS.STAFF_TAX_SHEET.key}
          >
            {activeKey === CATEGORY_STATUS_TABS.STAFF_TAX_SHEET.key && (
              <StaffTaxSheetCategoryStatus />
            )}
          </Tabs.TabPane> */}
          <Tabs.TabPane
            tab={CATEGORY_STATUS_TABS.WORKERS.label}
            key={CATEGORY_STATUS_TABS.WORKERS.key}
          >
            {activeKey === CATEGORY_STATUS_TABS.WORKERS.key && (
              <WorkerListCategoryStatus />
            )}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={CATEGORY_STATUS_TABS.BIZ_SHEET.label}
            key={CATEGORY_STATUS_TABS.BIZ_SHEET.key}
          >
            {activeKey === CATEGORY_STATUS_TABS.BIZ_SHEET.key && (
              <BizSheetCategoryStatus />
            )}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={CATEGORY_STATUS_TABS.CUSTOMER.label}
            key={CATEGORY_STATUS_TABS.CUSTOMER.key}
          >
            {activeKey === CATEGORY_STATUS_TABS.CUSTOMER.key && (
              <CustomerCategoryStatus />
            )}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={CATEGORY_STATUS_TABS.COMPANY_POLICIES.label}
            key={CATEGORY_STATUS_TABS.COMPANY_POLICIES.key}
          >
            {activeKey === CATEGORY_STATUS_TABS.COMPANY_POLICIES.key && (
              <CompanyPoliciesCategoryStatus />
            )}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={CATEGORY_STATUS_TABS.BUSINESS_MANUALS.label}
            key={CATEGORY_STATUS_TABS.BUSINESS_MANUALS.key}
          >
            {activeKey === CATEGORY_STATUS_TABS.BUSINESS_MANUALS.key && (
              <Tabs
                defaultActiveKey={
                  BUSINESS_MANUALS_SUB_TABS.BUSINESS_MANUALS.key
                }
                activeKey={businessManualSubTab}
                onChange={onBusinessManualSubTabChange}
                className="business-manuals-sub-tabs"
              >
                <Tabs.TabPane
                  tab={
                    <Tooltip title="開発中" color="#6BC77A">
                      <span>
                        {BUSINESS_MANUALS_SUB_TABS.JOB_AUTHORITY_MATRIX.label}
                      </span>
                    </Tooltip>
                  }
                  key={BUSINESS_MANUALS_SUB_TABS.JOB_AUTHORITY_MATRIX.key}
                  disabled
                >
                  <div></div>
                </Tabs.TabPane>
                <Tabs.TabPane
                  tab={BUSINESS_MANUALS_SUB_TABS.BUSINESS_MANUALS.label}
                  key={BUSINESS_MANUALS_SUB_TABS.BUSINESS_MANUALS.key}
                >
                  {businessManualSubTab ===
                    BUSINESS_MANUALS_SUB_TABS.BUSINESS_MANUALS.key && (
                    <BusinessManualsCategoryStatus />
                  )}
                </Tabs.TabPane>
                <Tabs.TabPane
                  tab={
                    <Tooltip title="開発中" color="#6BC77A">
                      <span className="text-muted-tab">
                        {BUSINESS_MANUALS_SUB_TABS.BUSINESS_FLOWCHART.label}
                      </span>
                    </Tooltip>
                  }
                  key={BUSINESS_MANUALS_SUB_TABS.BUSINESS_FLOWCHART.key}
                  disabled
                >
                  <div></div>
                </Tabs.TabPane>
              </Tabs>
            )}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={CATEGORY_STATUS_TABS.PROJECT_MANAGEMENT.label}
            key={CATEGORY_STATUS_TABS.PROJECT_MANAGEMENT.key}
          >
            {activeKey === CATEGORY_STATUS_TABS.PROJECT_MANAGEMENT.key && (
              <ProjectManagementStatus />
            )}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={CATEGORY_STATUS_TABS.APPRAISALS.label}
            key={CATEGORY_STATUS_TABS.APPRAISALS.key}
          >
            <div></div>
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={CATEGORY_STATUS_TABS.APPRAISAL_SHEETS.label}
            key={CATEGORY_STATUS_TABS.APPRAISAL_SHEETS.key}
          >
            <div></div>
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={CATEGORY_STATUS_TABS.BUSINESS_TRIP_REPORTS.label}
            key={CATEGORY_STATUS_TABS.BUSINESS_TRIP_REPORTS.key}
          >
            {activeKey === CATEGORY_STATUS_TABS.BUSINESS_TRIP_REPORTS.key && (
              <BusinessTripReportsCategoryStatus />
            )}
          </Tabs.TabPane>
          {/* <Tabs.TabPane
            tab={CATEGORY_STATUS_TABS.WORKERS.label}
            key={CATEGORY_STATUS_TABS.WORKERS.key}
          >
            {activeKey === CATEGORY_STATUS_TABS.WORKERS.key && (
              <WorkerListCategoryStatus />
            )}
          </Tabs.TabPane> */}
        </Tabs>
      </div>
    </Styles>
  );
};

const CategoryStatusConfig: FC<ReceivedProps> = (props) => (
  <CategoryStatusConfigLayout {...useCategoryStatusConfig(props)} />
);

export default CategoryStatusConfig;
